import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ParticipantStateType, ConversationParticipantsListResponseType } from 'src/shared/types/src';

const initialState: ParticipantStateType = {
  loading: false,
  participantGroups: [],
};

const conversationParticipantSlice = createSlice({
  name: 'conversationParticipantSlice',
  initialState,
  reducers: {
    setConversationParticipantLoader: (
      state,
      action: PayloadAction<{ loading: boolean }>
    ) => {
      state.loading = action.payload.loading;
    },
    setConversationParticipants: (
      state,
      action: PayloadAction<{ list: ConversationParticipantsListResponseType[] }>
    ) => {
      state.participantGroups = action.payload.list;
    },
    resetConversationParticipantState: (state, action) => {
      return {
        ...initialState
      };
    },
  },
});

export const ConversationParticipantActions = conversationParticipantSlice.actions;
export default conversationParticipantSlice.reducer;
